export default {
      id: "file-upload-icon-usage",
      viewBox: "0 0 545 545",
      url: __webpack_public_path__ + "sprite.svg#file-upload-icon",
      toString: function () {
        return this.url;
      }
    }